import Home from './Home.pid-lists.vue'

export default {
  Home
}